export function isPromise<PromiseType>(
  obj: PromiseType | Promise<PromiseType>
): obj is Promise<PromiseType> {
  return (
    Boolean(obj) && typeof obj === 'object' && typeof (obj as unknown as any).then === 'function'
  )
}
